module.exports = __webpack_public_path__ + "img/JHSLS_IOS.9b9f8bd5.png";